<template>
  <div class="addActivities">
    <div class="main">

         <div class="box">
          <div class="box-left">
            酒吧名称：<span>{{form.barName}}</span>
          </div>
          <div class="box-right">
            城市：<span>{{form.cityName}}</span>
          </div>
       </div>
        <div class="box">
          <div class="box-left">
            酒吧负责人：<span> {{form.responsiblePersonName}}</span>
          </div>
          <div class="box-right">
            酒吧负责人手机号：<span>{{form.responsiblePersonPhone}}</span>
          </div>

       </div>
          <div class="box">
          <div class="box-left">
            酒吧电话：<span> {{form.barPhone}}</span>
          </div>
          <div class="box-right">
            酒吧负责人微信：<span>{{form.responsiblePersonWx}}</span>
          </div>

       </div>
       <div class="box">
          <div class="box-right">
            营业时间：<span>{{form.businessHours}}</span>
          </div>
       </div>

        <div class="box">
          <div class="box-right">
            营业时间备注：<span>{{form.businessHoursNote}}</span>
          </div>
       </div>
         <div class="box">
          <div class="box-right">
            酒吧详细地址：<span>{{form.detailedAddress}}</span>
          </div>
       </div>
         <div class="box">
          <div class="box-right">
            酒吧邮寄地址：<span>{{form.mailingAddress}}</span>
          </div>
       </div>
         <div class="box">
          <div class="box-left">
            酒头数量：<span>{{form.wineHeadNum}}</span>
          </div>
          <div class="box-right">
            酒瓶数量：<span>{{form.bottlesNum}}</span>
          </div>
       </div>
       <div class="box">
          <div class="box-right">
            特点介绍：<span>{{form.featuresIntroduced}}</span>
          </div>
       </div>
        <div class="box">
          <div class="box-label">
            标签：
            <div v-for="(item,i) in form.labels" :key='i'>
                   {{item.name}}
            </div>
          </div>
       </div>
           <div class="box">
          <div >
             <div> 营业执照：</div>
             <div class="box-img">
                <el-image class="img" :src="form.businessLicense"    :preview-src-list='[form.businessLicense]'></el-image>
             </div>
         
          </div>
       </div> 

          <div class="box">
          <div >
             <div> 酒吧封面：</div>
             <div class="box-img">
                <el-image class="img" :src="form.cover"    :preview-src-list='[form.cover]'></el-image>
             </div>
         
          </div>
       </div> 
        <div class="box">
          <div >
             <div> 酒吧照片：</div>
             <div class="box-img">
                <el-image class="img" :src="item.url" v-for="(item,i) in form.imageVos" :key='i'   :preview-src-list='[item.url]'></el-image>
             </div>
         
          </div>
       </div> 
       <div class="box">
          <div class="box-right">
            登录账号：<span>{{form.loginAccount}}</span>
          </div>
       </div>
        <div class="box">
          <div class="box-right">
            登录密码：<span>{{form.loginPassword}}</span>
          </div>
       </div>
         <div class="box">
          <div class="box-right">
            首次进店优惠：<span>{{form.preferentialEntryPolicy}}</span>
          </div>
       </div>
        <div class="box">
           <div>
               <div >
            长期优惠：
          </div>
          <div class="box-discounts">
            <p>折扣范围：<span>{{form.discountsScope}}</span></p>
            <p>折扣力度：<span>{{form.discounts}}折</span></p>
            <p>备注：<span>{{form.note}}</span></p>
          </div>
           </div>
       </div>
          <div class="box">
           <div>
               <div >
            你是否愿意给顿友 提供打酒壶优惠？
          </div>
          <div class="box-discounts">
            <p><span>{{form.isDiscountOnBeaker?'愿意给顿友 提供打酒壶优惠':'不愿意给顿友 提供打酒壶优惠'}}</span></p>
            <p>优惠⼒度：<span>{{form.breaks}}</span></p>
    
          </div>
           </div>
       </div>
    </div>
    <div class="btn" v-if="form.auditType == 0">
      <el-button type="success" @click="examine(form.id, 1)">通过</el-button>
      <el-button type="danger" @click="examine(form.id, 2)">拒绝</el-button>
    </div>
  </div>
</template>

<script>

import { IP, webBarDetail, webBarExamine } from "@/api/api";

export default {
 

  data() {
    const self = this;
    return {
      defaultProps: {
        children: "children",
        label: "name",
      },
      customerData: [],
      adminId: "",
      // 图片上传地址
      imgURL: IP + "/images/uploadImage",
      // imgURL: IP + "/obs/uploadImage",
      dialogImageUrl: "",
      dialogVisible: false,
      form: {
        id: "",
        cover: "",
        //登录账号
        loginAccount: "",
        //登录密码
        loginPassword: "",
        //坐标
        coordinate: "",
        //酒吧名称
        barName: "",
        //负责人名称
        responsiblePersonName: "",
        //负责人手机号
        responsiblePersonPhone: "",
        //负责人微信号
        responsiblePersonWx: "",
        //城市名称
        cityName: "",
        //省份
        province: "",
        //详细地址
        detailedAddress: "",
        //邮寄地址
        mailingAddress: "",
        //酒头数量
        wineHeadNum: "",
        //酒瓶数量
        bottlesNum: "",
        //特点介绍
        featuresIntroduced: "",
        //首次是否提供优惠
        firstTimeDiscount: "",
        //首次进店优惠政策
        preferentialEntryPolicy: "",
        //折扣范围
        discountsScope: "",
        //备注
        note: "",
        //营业时间
        businessHours: "",
        //折扣力度
        discounts: "",
        //你是否愿意给顿友提供打酒壶优惠
        isDiscountOnBeaker: "",
        //优惠力度
        breaks: "",
        //审核状态（0审核中 1审核通过 2审核不通过）
        auditType: "",
        //图片
        imageVos: [],
        //标签
        labels: [],
      },
   
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    //  获取酒吧详情
    async getDetail() {
      let res = await webBarDetail({
        barId: this.$route.query.barId,
      });
      res.data.businessHours=res.data.businessHours.split(',').join('-')
      this.form=res.data
      console.log( this.form)
    },

    async examine(id, type) {
      let res = await webBarExamine({
        barId: id,
        type: type,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "审核成功",
        });
        this.$router.push("barExamine?currentPage="+this.$route.query.currentPage+"&pageSize="+this.$route.query.pageSize+"&value="+this.$route.query.value+"&query="+this.$route.query.query+"&startTime="+this.$route.query.startTime+"&endTime="+this.$route.query.endTime);
      }
    },






  },
};
</script>

<style lang="less" scoped>
.addActivities {
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: scroll;
  .main {
    padding: 60px;
    .box {
      display: flex;
      margin-bottom: 35px;
      .box-left {
        width: 300px;
        display: flex;
        align-items: center;
      }
      .box-label {
        display: flex;
        align-items: center;
        div {
          padding: 10px 20px;
          background: #ffb423;
          margin-left: 16px;
          border-radius: 5px;
        }
      }
      .box-img {
        margin-top: 23px;
        .img {
          width: 200px;
          height: 160px;
          margin-right: 26px;
          margin-bottom: 26px;
        }
      }
      .box-discounts{
      
        p{
          padding: 13px 30px 0;
          color: #727070 ;
        }
      }
    }
  }
  .btn{
    padding:0 60px;
  }
}




</style>